import React, { useEffect, useState } from 'react'
import './home.css'

const Home = () => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 100)
    return () => clearTimeout(timer)
  }, [])

  const scrollToServices = () => {
    const servicesSection = document.getElementById('services');
    if (servicesSection) {
      servicesSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className='home' id='home'>
      <div className="home__overlay"></div>
      <div className="home__glow"></div>

      <div className={`hero-shell ${visible ? 'visible' : ''}`}>
        <div className="hero-content">
          <p className="hero-overline">PRIVATE LOUNGE BOOKINGS</p>
          <h1 className="hero-headline">Hookup Lounge</h1>
          <p className="hero-subtext">
            A discreet private lounge with jacuzzi warmth, spa calm, indulgent food,
            and curated fantasy-ready spaces.
          </p>
          <div className="hero-buttons">
            <a href="https://t.me/mainhookupmanagement" className="hero-btn hero-btn--primary">
              Book Now on Telegram
            </a>
            <button onClick={scrollToServices} className="hero-btn hero-btn--secondary">
              View Experiences
            </button>
          </div>
        </div>

        <div className="hero-feature" aria-label="Hookup Lounge highlights">
          <div className="hero-feature__image"></div>
          <div className="hero-feature__panel">
            <span>All-Inclusive Escape</span>
            <strong>Jacuzzi, buffet, spa, and private fantasy rooms in one booking.</strong>
          </div>
        </div>
      </div>

      <div className="hero-marquee-container">
        <div className="hero-marquee">
          <div className="marquee-group">
            <span>Ashley Madison</span>
            <span>BeNaughty</span>
            <span>Tinder</span>
            <span>Badoo</span>
            <span>Plenty of Fish</span>
          </div>
          <div className="marquee-group">
            <span>Ashley Madison</span>
            <span>BeNaughty</span>
            <span>Tinder</span>
            <span>Badoo</span>
            <span>Plenty of Fish</span>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Home
